<template>
	<rb-thumbnail
		class="rb-video-thumbnail"
		:image-url="small ? video.getSmallThumbnail() : video.Thumbnail"
		v-bind="$attrs"
		v-on="$listeners"
		:to="video.getRoute()"
	>
		<div class="rb-head" slot="head" v-if="!hideText">
			<span class="text-xs text-right float-right">
				{{ video.Views }} <rb-icon>eye</rb-icon>

				<rb-badge
					circle class="text-success ml-1"
					v-b-tooltip.hover.bottomleft
					:title="`Assistido`"
					v-if="watched"
				>
					<rb-icon>check</rb-icon>
				</rb-badge>
			</span>

			<div class="rb-title text-xs">
				{{ video.Name }}

				<rb-icon class="text-first" v-if="nowLazy < video.getPubliclyAvailableTime()">
					star
				</rb-icon>
			</div>

			<div class="rb-date text-xxs">
				{{ video.Date.format('d/m/Y') }}
			</div>
		</div>

		<span class="rb-play-slot" :class="[`text-${playSize}`]" slot="center">
			<rb-icon class="rb-play">play</rb-icon>
		</span>
	</rb-thumbnail>
</template>

<script>
	import RbThumbnail from './RbThumbnail';
	import Video from '../../../shared/entities/Video';
	import {mapState} from 'vuex';
	import RbBadge from './RbBadge';
	import {oldApi} from '../app/oldApi';

	export default {
		name: 'RbVideoThumbnail',
		components: {RbBadge, RbThumbnail},
		props: {
			video: {
				type: Video,
				required: true
			},
			hideText: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			playSize: {
				type: String,
				default: 'md'
			}
		},
		data: () => ({
			watched: false
		}),
		watch: {
			video(newVideo, oldVideo) {
				if (!oldVideo || newVideo.Id !== oldVideo.Id) {
					this.watched = false;
					this.loadWatched();
				}
			}
		},
		mounted() {
			this.loadWatched();
		},
		computed: {
			...mapState([
				'nowLazy'
			]),
		},
		methods: {
			async loadWatched() {
				if (!this.video) return;

				const views = await oldApi.Video.hasBeenViewed(this.video.Id);
				this.watched = views.Views;
			}
		}
	}
</script>

<style lang="scss" scoped>

	.rb-video-thumbnail {
		color: $light;
		text-shadow: 0 0 5px rgba(0, 0, 0, .5);
		transition: all 0.5s ease 0s;

		.rb-head {
			line-height: 1.2em;

			.rb-date {
				color: $grey;
			}
		}

		.rb-play-slot {
			color: $light;
			opacity: .5;
			transition: all 0.5s ease 0s;
		}

		.rb-play {
			font-size: 2em;
			filter: drop-shadow(0 0 5px rgba(0, 0, 0, .2));
			transition: filter 0.5s ease 0s;
			opacity: 0;
		}

		&.active {
			.rb-play {
				opacity: 1;
			}
		}

		&.active:hover {
			color: $highlight;
			text-shadow: 0 0 5px rgba(255, 255, 255, .5);

			.rb-play-slot {
				opacity: .9;
				color: $primary;
			}
			.rb-play {
				filter: drop-shadow(0 0 8px rgba(0, 0, 0, .5));
			}
		}
	}
</style>
